import { render } from "./CreateProduct.vue?vue&type=template&id=b2fa3590&scoped=true"
import script from "./CreateProduct.vue?vue&type=script&lang=js"
export * from "./CreateProduct.vue?vue&type=script&lang=js"

import "./CreateProduct.vue?vue&type=style&index=0&id=b2fa3590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fa3590"]])

export default __exports__